/**
 * Must match `ANALYTICS_ALL_SITES_URL_SEGMENT` in st-ck-server
 * `src/helpers/infralytiqs/analyticsScope.ts`.
 */
export const IL_ANALYTICS_ALL_SITES_SEGMENT = '__all_sites__';

/** URL path segment for `/il/analytics/:tenant/:segment/...` when Site ID is blank (all sites). */
export function infralytiqsAnalyticsSitePathSegment(siteId?: string | null): string {
  const t = siteId?.trim();
  return t ? t : IL_ANALYTICS_ALL_SITES_SEGMENT;
}
